import { ICompositeComponent, IGenericControl, IHasEncryptionState } from "../../Controls/ControlInterfaces";
import { ILoader } from "../../ILoader";
import { IFormControl } from "../FormControl";
import {
    IFrameWithChildFrames,
    IFrameWithKeyboardNavigation,
    IMasterableFrame,
    IMasterableFrameWithDataGrid,
    IMultiRecordsComponent,
} from "./FrameInterfaces";
import { IDetailMasterableFrame } from "./IDetailMasterableFrame";
import { IEditableFrame } from "./IEditableFrame";

export interface ITreeFrame extends IFormControl, IHasEncryptionState, ILoader, IGenericControl, ICompositeComponent, IMasterableFrameWithDataGrid, IDetailMasterableFrame, IEditableFrame, IMultiRecordsComponent, IFrameWithKeyboardNavigation, IFrameWithChildFrames {
    readonly isTreeFrame: boolean;
    /**
     * Vrací, zda je předaný frame přímou subkomponentou TLF
     */
    isSubframe(frame: IMasterableFrame): boolean;
}

export class ITreeFrame {
    private static _properties: (keyof ITreeFrame)[] = ["isTreeFrame"];

    private static _methods: (keyof ITreeFrame)[] = [
        "isSubframe",
    ];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null &&
            !this._properties.some((value) => !Reflect.has(instance, value)) &&
            !this._methods.some(value => typeof instance[value] !== "function");
    }
}
